(function () {

  function initNavBar(nav) {
    var sectionId = nav.dataset.collNavId;
    if (!sectionId) return;

    var track = document.getElementById('coll-nav-track-' + sectionId);
    var prev  = document.getElementById('coll-nav-prev-' + sectionId);
    var next  = document.getElementById('coll-nav-next-' + sectionId);
    if (!track || !prev || !next) return;

    /* Scroll active pill into view on load */
    var active = track.querySelector('.coll-nav-pill--active');
    if (active) {
      requestAnimationFrame(function () {
        active.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });
      });
    }

    function updateArrows() {
      var isDesktop = window.innerWidth > 767;
      var overflows = track.scrollWidth > track.clientWidth + 2;

      if (!isDesktop || !overflows) {
        prev.style.display = 'none';
        next.style.display = 'none';
        return;
      }

      prev.style.display = 'flex';
      next.style.display = 'flex';

      var atStart = track.scrollLeft <= 2;
      var atEnd   = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;

      prev.style.opacity       = atStart ? '0.3' : '1';
      prev.style.pointerEvents = atStart ? 'none' : 'auto';
      next.style.opacity       = atEnd   ? '0.3' : '1';
      next.style.pointerEvents = atEnd   ? 'none' : 'auto';
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -200, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left:  200, behavior: 'smooth' }); });

    track.addEventListener('scroll', updateArrows, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateArrows, 80);
    });

    window.addEventListener('load', updateArrows);
    setTimeout(updateArrows, 120);
  }

  function initAll() {
    document.querySelectorAll('.coll-nav-bar[data-coll-nav-id]').forEach(initNavBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var nav = e.target.querySelector('.coll-nav-bar[data-coll-nav-id]');
    if (nav) initNavBar(nav);
  });

})();
